import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "fb_admin_token";

function authHeaders() {
  const t = localStorage.getItem(TOKEN_KEY);
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export const adminApi = {
  listWorkshops: () =>
    axios.get(`${API}/admin/workshops`, { headers: authHeaders() }).then((r) => r.data),
  createWorkshop: (data) =>
    axios.post(`${API}/admin/workshops`, data, { headers: authHeaders() }).then((r) => r.data),
  updateWorkshop: (id, data) =>
    axios.patch(`${API}/admin/workshops/${id}`, data, { headers: authHeaders() }).then((r) => r.data),
  deleteWorkshop: (id) =>
    axios.delete(`${API}/admin/workshops/${id}`, { headers: authHeaders() }).then((r) => r.data),
  listRegistrations: () =>
    axios.get(`${API}/admin/registrations`, { headers: authHeaders() }).then((r) => r.data),
  listContacts: () =>
    axios.get(`${API}/admin/contacts`, { headers: authHeaders() }).then((r) => r.data),
  listLeads: () =>
    axios.get(`${API}/admin/leads`, { headers: authHeaders() }).then((r) => r.data),
  listNewsletter: () =>
    axios.get(`${API}/admin/newsletter`, { headers: authHeaders() }).then((r) => r.data),
  listNotifications: () =>
    axios.get(`${API}/admin/notifications`, { headers: authHeaders() }).then((r) => r.data),
};
